angular.module('homebot.directives')

  .directive('sectionSuccess', ['$timeout', function($timeout){
    return {
      restrict: 'E',
      controllerAs: 'successCtrl',
      bindToController: {
        content: '@'
      },
      templateUrl: '/homes/templates/partials/section-success.html',
      controller: function(){},
      scope: {},
      link: function(){}
    }

  }]);
